import * as types from '../types';
import { NoSaveAction, PracticeData, PracticeDataUpdateAction, ResetEditableAction } from '../types';


export const updatePracticeData = (practiceDataUpdate: PracticeData) => {
    
    return {
      type: PracticeDataUpdateAction.UPDATE_PRACTICE_DATA,
      practiceDataUpdate,
    };
  };

export const resetEditbale = (flag: boolean): ResetEditableAction => {
  return{
    type: PracticeDataUpdateAction.RESET_EDITABLE,
    flag
  };
};

export const noSave = (save: boolean): NoSaveAction => {
  return {
    type: PracticeDataUpdateAction.NO_SAVE,
    save
  };
};